<template>
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 19.9502L19.2929 13.6573C19.6834 13.2668 19.6834 12.6336 19.2929 12.2431L13 5.9502"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5 19.9502L11.2929 13.6573C11.6834 13.2668 11.6834 12.6336 11.2929 12.2431L5 5.9502"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
